import React, { memo } from "react";
import { styled } from "@mui/system";

import { Icon, ICONS } from "../../Icons";

const StyledErrorMessageWrapper = styled("div")(({ theme }) => ({
  fontSize: "12px",
  position: "relative",
  "& p": {
    lineHeight: "1.1",
    margin: "0",
    color: "#ea2b1e",
    maxWidth: "fit-content",
    paddingRight: "50px",
    [theme.breakpoints.up("sm")]: {
      lineHeight: "1",
      width: "auto",
      maxWidth: "fit-content",
      paddingRight: "30px"
    }
  },
  "& svg": {
    marginRight: "5px"
  },
  "& .errorContainer": {
    marginTop: "10px",
    display: "flex",
    alignItems: "center"
  }
}));

const ErrorMessageBase = ({ classes, error }) => {
  return (
    <StyledErrorMessageWrapper className={classes?.error} data-testid="error-message-wrapper">
      <div className="errorContainer">
        <Icon name={ICONS.error} alt="error" />
        {error && <p>{error}</p>}
      </div>
    </StyledErrorMessageWrapper>
  );
};
export const ErrorMessage = memo(ErrorMessageBase);
